import { actualizarProductoBase } from '../infraestructure/supabase/productosPrecio.repository.js'

export async function actualizarProductoPrecioUseCase(id, cambios) {

  if (!id) {
    return { success: false, error: "ID es requerido" };
  }

  if (!cambios || Object.keys(cambios).length === 0) {
    return { success: false, error: "No hay cambios para actualizar" };
  }

  const res = await actualizarProductoBase(id, cambios);

  return res;
}